module.exports = __webpack_public_path__ + "static/img/img2.a108c10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/public/img2.png
// module id = rmuT
// module chunks = 3